import { InstallationPriceSimulationRequest } from './installation-price-simulation-request.types'
import { IInstallationPriceSimulationRepository } from '@modules/installation-price-simulation/domain'
import { solarProductAxios } from '@infrastructure/apiService'

export const InstallationPriceSimulationService: IInstallationPriceSimulationRepository =
  {
    simulate: async (params: InstallationPriceSimulationRequest) => {
      const { data } = await solarProductAxios.post(
        '/private/installation-price/simulate',
        params
      )
      return data
    },
  }
